import {atom } from 'recoil';

export const countriesList = new atom({
    key: 'countriesListState',
    default: [],
})